import { Injectable } from "@angular/core";
import {
    GetMessageHistoryUsecaseInput,
    GetMessagesHistoryUsecase
} from "@arch/domain/application/usecase/get-messages-history.usecase";
import { MessagesHistoryResponse } from "@arch/domain/gateway/data-communication.gateway.interface";

@Injectable({
    providedIn: "root"
})
export class GetMessagesHistoryController {
    constructor(
        private readonly getMessagesHistoryUsecase: GetMessagesHistoryUsecase
    ) {}

    public async execute(
        input: GetMessageHistoryUsecaseInput
    ): Promise<MessagesHistoryResponse> {
        const response = await this.getMessagesHistoryUsecase.execute(input);
        return response;
    }
}
